import { render, staticRenderFns } from "./remind.vue?vue&type=template&id=5c706a64"
import script from "./remind.vue?vue&type=script&lang=js"
export * from "./remind.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports